/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  badge: {
    radius: "0.25rem",
    height: "1.5rem",
  },
  button: {
    radius: "0.25rem",
    height: {
      small: "2.25rem",
      medium: "2.75rem",
      large: "3.25rem",
    },
  },
  checkbox: {
    size: "1.25rem",
    marker: {
      size: "0.75rem",
    },
    label: {
      gap: "0.5rem",
    },
  },
  form: {
    widget: {
      radius: "0.25rem",
      height: {
        small: "2.25rem",
        medium: "2.75rem",
        large: "3.25rem",
      },
      surface: {
        color: {
          base: "white",
          error: "hsl(15deg 93% 94%)",
          readonly: "hsl(0deg 0% 98%)",
          disabled: "hsl(0deg 0% 98%)",
        },
      },
      text: {
        color: {
          base: "hsl(0deg 0% 12%)",
          placeholder: "hsl(0deg 0% 46%)",
          readonly: "hsl(0deg 0% 12%)",
          disabled: "hsl(0deg 0% 46%)",
        },
      },
      marker: {
        color: {
          base: "hsl(0deg 0% 12%)",
          checked: "hsl(180deg 78% 34%)",
          disabled: "hsl(0deg 0% 46%)",
        },
      },
      border: {
        color: {
          base: "hsl(0deg 0% 12%)",
          hover: "hsl(180deg 78% 45%)",
          focus: "hsl(180deg 78% 45%)",
          checked: "hsl(180deg 78% 34%)",
          error: "hsl(4deg 61% 51%)",
          readonly: "hsl(0deg 0% 46%)",
          disabled: "hsl(0deg 0% 46%)",
        },
        size: "1px",
      },
    },
  },
  header: {
    height: "3rem",
  },
  pill: {
    radius: "999px",
    height: {
      small: "1.5rem",
      medium: "1.75rem",
    },
  },
  radio: {
    size: "1.25rem",
    marker: {
      size: "0.75rem",
    },
    label: {
      gap: "0.5rem",
    },
  },
  switch: {
    width: "2.25rem",
    label: {
      gap: "0.5rem",
    },
  },
  tag: {
    radius: "999px",
    height: "1.25rem",
  },
  color: {
    duckBlue: {
      "50": "hsl(180deg 67% 93%)",
      "100": "hsl(180deg 72% 86%)",
      "200": "hsl(180deg 75% 64%)",
      "300": "hsl(180deg 78% 45%)",
      "400": "hsl(180deg 82% 37%)",
      "500": "hsl(180deg 78% 34%)",
      "600": "hsl(180deg 74% 32%)",
      "700": "hsl(180deg 72% 28%)",
      "800": "hsl(180deg 67% 24%)",
      "900": "hsl(180deg 63% 17%)",
    },
    ashBlack: {
      "25": "hsl(0deg 0% 98%)",
      "50": "hsl(0deg 0% 96%)",
      "100": "hsl(0deg 0% 91%)",
      "200": "hsl(0deg 0% 83%)",
      "300": "hsl(0deg 0% 71%)",
      "400": "hsl(0deg 0% 58%)",
      "500": "hsl(0deg 0% 46%)",
      "600": "hsl(0deg 0% 27%)",
      "700": "hsl(0deg 0% 18%)",
      "800": "hsl(0deg 0% 12%)",
      "900": "hsl(0deg 0% 7%)",
    },
    neonPurple: {
      "25": "hsl(253deg 100% 98%)",
      "50": "hsl(253deg 100% 96%)",
      "100": "hsl(251deg 100% 93%)",
      "200": "hsl(252deg 100% 85%)",
      "300": "hsl(252deg 98% 77%)",
      "400": "hsl(252deg 99% 70%)",
      "500": "hsl(259deg 88% 59%)",
      "600": "hsl(259deg 62% 48%)",
      "700": "hsl(259deg 65% 42%)",
      "800": "hsl(259deg 64% 34%)",
      "900": "hsl(267deg 85% 26%)",
    },
    streamBlue: {
      "25": "hsl(210deg 100% 98%)",
      "50": "hsl(206deg 100% 97%)",
      "100": "hsl(209deg 100% 91%)",
      "200": "hsl(206deg 100% 76%)",
      "300": "hsl(207deg 98% 66%)",
      "400": "hsl(211deg 95% 58%)",
      "500": "hsl(218deg 80% 46%)",
      "600": "hsl(220deg 75% 38%)",
      "700": "hsl(218deg 68% 31%)",
      "800": "hsl(218deg 84% 19%)",
      "900": "hsl(243deg 63% 12%)",
    },
    acidGreen: {
      "25": "hsl(159deg 100% 97%)",
      "50": "hsl(159deg 100% 94%)",
      "100": "hsl(160deg 89% 89%)",
      "200": "hsl(160deg 89% 79%)",
      "300": "hsl(160deg 88% 68%)",
      "400": "hsl(160deg 88% 57%)",
      "500": "hsl(160deg 100% 47%)",
      "600": "hsl(160deg 77% 49%)",
      "700": "hsl(160deg 75% 44%)",
      "800": "hsl(160deg 58% 41%)",
      "900": "hsl(160deg 58% 36%)",
      "1000": "hsl(160deg 83% 21%)",
    },
    poppyRed: {
      "25": "hsl(0deg 100% 99%)",
      "50": "hsl(15deg 100% 97%)",
      "100": "hsl(15deg 93% 94%)",
      "200": "hsl(14deg 96% 90%)",
      "300": "hsl(11deg 100% 85%)",
      "400": "hsl(7deg 100% 77%)",
      "500": "hsl(4deg 100% 73%)",
      "600": "hsl(4deg 99% 65%)",
      "700": "hsl(4deg 89% 61%)",
      "800": "hsl(4deg 75% 56%)",
      "900": "hsl(4deg 61% 51%)",
      "1000": "hsl(4deg 66% 38%)",
    },
    clockworkOrange: {
      "25": "hsl(44deg 100% 98%)",
      "50": "hsl(44deg 100% 96%)",
      "100": "hsl(44deg 98% 89%)",
      "200": "hsl(44deg 99% 77%)",
      "300": "hsl(42deg 99% 65%)",
      "400": "hsl(39deg 98% 56%)",
      "500": "hsl(34deg 94% 50%)",
      "600": "hsl(25deg 86% 53%)",
      "700": "hsl(22deg 82% 51%)",
      "800": "hsl(22deg 90% 45%)",
      "900": "hsl(15deg 78% 46%)",
    },
    laserYellow: {
      "25": "hsl(60deg 100% 97%)",
      "50": "hsl(60deg 100% 95%)",
      "100": "hsl(59deg 100% 89%)",
      "200": "hsl(59deg 100% 84%)",
      "300": "hsl(59deg 100% 79%)",
      "400": "hsl(59deg 100% 73%)",
      "500": "hsl(57deg 83% 71%)",
      "600": "hsl(53deg 55% 66%)",
      "700": "hsl(49deg 34% 57%)",
      "800": "hsl(45deg 29% 45%)",
      "900": "hsl(42deg 26% 40%)",
    },
    primary: {
      "25": "hsl(0deg 0% 98%)",
      "50": "hsl(0deg 0% 96%)",
      "100": "hsl(0deg 0% 91%)",
      "200": "hsl(0deg 0% 83%)",
      "300": "hsl(0deg 0% 71%)",
      "400": "hsl(0deg 0% 58%)",
      "500": "hsl(0deg 0% 46%)",
      "600": "hsl(0deg 0% 27%)",
      "700": "hsl(0deg 0% 18%)",
      "800": "hsl(0deg 0% 12%)",
      "900": "hsl(0deg 0% 7%)",
      weak: "hsl(0deg 0% 83%)",
      plain: "hsl(0deg 0% 46%)",
      strong: "hsl(0deg 0% 12%)",
    },
    brand: {
      "50": "hsl(180deg 67% 93%)",
      "100": "hsl(180deg 72% 86%)",
      "200": "hsl(180deg 75% 64%)",
      "300": "hsl(180deg 78% 45%)",
      "400": "hsl(180deg 82% 37%)",
      "500": "hsl(180deg 78% 34%)",
      "600": "hsl(180deg 74% 32%)",
      "700": "hsl(180deg 72% 28%)",
      "800": "hsl(180deg 67% 24%)",
      "900": "hsl(180deg 63% 17%)",
      weaker: "hsl(180deg 67% 93%)",
      weak: "hsl(180deg 72% 86%)",
      plain: "hsl(180deg 78% 34%)",
      strong: "hsl(180deg 63% 17%)",
    },
    neutral: {
      "25": "hsl(0deg 0% 98%)",
      "50": "hsl(0deg 0% 96%)",
      "100": "hsl(0deg 0% 91%)",
      "200": "hsl(0deg 0% 83%)",
      "300": "hsl(0deg 0% 71%)",
      "400": "hsl(0deg 0% 58%)",
      "500": "hsl(0deg 0% 46%)",
      "600": "hsl(0deg 0% 27%)",
      "700": "hsl(0deg 0% 18%)",
      "800": "hsl(0deg 0% 12%)",
      "900": "hsl(0deg 0% 7%)",
      weak: "hsl(0deg 0% 83%)",
      plain: "hsl(0deg 0% 46%)",
      strong: "hsl(0deg 0% 12%)",
    },
    accent: {
      weaker: "hsl(180deg 67% 93%)",
      weak: "hsl(180deg 72% 86%)",
      plain: "hsl(180deg 78% 34%)",
      strong: "hsl(180deg 67% 24%)",
    },
    informative: {
      weak: "hsl(209deg 100% 91%)",
      plain: "hsl(206deg 100% 76%)",
      strong: "hsl(218deg 80% 46%)",
    },
    positive: {
      weak: "hsl(159deg 100% 97%)",
      plain: "hsl(160deg 77% 49%)",
      strong: "hsl(160deg 83% 21%)",
    },
    negative: {
      weak: "hsl(15deg 93% 94%)",
      plain: "hsl(4deg 100% 73%)",
      strong: "hsl(4deg 61% 51%)",
    },
    notice: {
      weak: "hsl(44deg 98% 89%)",
      plain: "hsl(39deg 98% 56%)",
      strong: "hsl(15deg 78% 46%)",
    },
    highlight: {
      weak: "hsl(14deg 96% 90%)",
      plain: "hsl(7deg 100% 77%)",
      strong: "hsl(4deg 99% 65%)",
    },
    premium: {
      plain: "hsl(11deg 100% 85%)",
    },
    progress: {
      weak: "hsl(209deg 100% 91%)",
      plain: "hsl(206deg 100% 76%)",
      strong: "hsl(218deg 80% 46%)",
    },
    background: "hsl(180deg 12% 95%)",
    surface: "white",
    overlay: "white",
    text: {
      base: "hsl(0deg 0% 12%)",
      plain: "hsl(0deg 0% 12%)",
      weak: "hsl(0deg 0% 46%)",
      link: "hsl(180deg 78% 34%)",
      informative: "hsl(218deg 80% 46%)",
      positive: "hsl(160deg 83% 21%)",
      negative: "hsl(4deg 61% 51%)",
      notice: "hsl(15deg 78% 46%)",
      highlight: "hsl(4deg 99% 65%)",
    },
  },
  duration: {
    "100": "130ms",
    "200": "160ms",
    "300": "190ms",
    "400": "220ms",
    "500": "250ms",
    "600": "300ms",
    "700": "350ms",
    "800": "400ms",
    "900": "450ms",
    "1000": "500ms",
    base: "190ms",
  },
  easing: {
    ease: "cubic-bezier(0.25, 0.1, 0.25, 1)",
  },
  shadow: {
    xsmall: "0px 1px 2px 0px hsl(0deg 0% 0% / 5%)",
    small: "0px 1px 2px 0px hsl(0deg 0% 0% / 6%), 0px 1px 3px 0px hsl(0deg 0% 0% / 10%)",
    medium: "0px 2px 4px -2px hsl(0deg 0% 0% / 6%), 0px 4px 8px -2px hsl(0deg 0% 0% / 10%)",
    large: "0px 4px 6px -2px hsl(0deg 0% 0% / 5%), 0px 12px 16px -4px hsl(0deg 0% 0% / 10%)",
  },
  font: {
    family: {
      text: "Inter, system-ui, sans-serif",
      display: "Fraunces, ui-serif, serif",
      monospace: "ui-monospace, monospace",
    },
    size: {
      xsmall: "12px",
      small: "14px",
      medium: "16px",
      large: "20px",
      xlarge: "24px",
      xxlarge: "36px",
      base: "14px",
      display: {
        xsmall: "16px",
        small: "20px",
        medium: "24px",
        large: "36px",
        xlarge: "44px",
        xxlarge: "48px",
      },
    },
    weight: {
      regular: "400",
      semibold: "600",
    },
  },
  lineHeight: {
    xsmall: 1.6667,
    small: 1.4286,
    medium: 1.5,
    large: 1.4,
    xlarge: 1.3333,
    xxlarge: 1.2222,
    display: {
      xsmall: 1.5,
      small: 1.4,
      medium: 1.3333,
      large: 1.2222,
      xlarge: 1.1818,
      xxlarge: 1.1667,
    },
  },
  border: {
    radius: {
      "100": "0.25rem",
      "150": "0.375rem",
      "200": "0.5rem",
      "250": "0.625rem",
      "300": "0.75rem",
      "350": "0.875rem",
      "400": "1rem",
      "450": "1.125rem",
      "500": "1.25rem",
      "600": "1.5rem",
      "700": "1.75rem",
      "1x": "0.25rem",
      "2x": "0.5rem",
      "050": "0.125rem",
      small: "0.25rem",
      medium: "0.5rem",
      pill: "999px",
      circle: "50%",
    },
    size: {
      "1x": "1px",
      "2x": "2px",
      small: "1px",
      medium: "2px",
    },
    color: {
      weak: "hsl(0deg 0% 83%)",
      base: "hsl(0deg 0% 83%)",
      strong: "hsl(0deg 0% 12%)",
    },
  },
  circle: {
    size: {
      "4x": "1rem",
      "6x": "1.5rem",
      "8x": "2rem",
      "10x": "2.5rem",
      "12x": "3rem",
    },
  },
  length: {
    base: "4px",
    "1x": "0.25rem",
    "2x": "0.5rem",
    "3x": "0.75rem",
    "4x": "1rem",
    "5x": "1.25rem",
    "6x": "1.5rem",
    "7x": "1.75rem",
    "8x": "2rem",
    "9x": "2.25rem",
    "10x": "2.5rem",
    "11x": "2.75rem",
    "12x": "3rem",
    "13x": "3.25rem",
    "16x": "4rem",
    "20x": "5rem",
    "24x": "6rem",
    "32x": "8rem",
    "40x": "10rem",
    "48x": "12rem",
    "56x": "14rem",
    "64x": "16rem",
  },
  widget: {
    height: {
      small: "2.25rem",
      medium: "2.75rem",
      large: "3.25rem",
    },
  },
  transition: {
    base: {
      duration: "190ms",
      delay: "0ms",
      timingFunction: "cubic-bezier(0.25, 0.1, 0.25, 1)",
    },
  },
  gradient: {
    brand: "hsl(180deg 75% 64%) 0%, hsl(160deg 77% 49%) 100%",
  },
  breakpoint: {
    xsmall: "27em",
    small: "40em",
    medium: "48em",
    large: "62.5em",
    xlarge: "75em",
    xxlarge: "90em",
    "3xlarge": "105em",
    "4xlarge": "120em",
  },
  icon: {
    size: {
      "2x": "0.5rem",
      "3x": "0.75rem",
      "4x": "1rem",
      "5x": "1.25rem",
      "6x": "1.5rem",
    },
  },
  spacing: {
    "1x": "0.25rem",
    "2x": "0.5rem",
    "3x": "0.75rem",
    "4x": "1rem",
    "5x": "1.25rem",
    "6x": "1.5rem",
    "7x": "1.75rem",
    "8x": "2rem",
    "10x": "2.5rem",
    "12x": "3rem",
    "16x": "4rem",
    "20x": "5rem",
    "24x": "6rem",
    "32x": "8rem",
    "40x": "10rem",
    "48x": "12rem",
    "56x": "14rem",
    "64x": "16rem",
  },
  outline: {
    width: "calc(1rem / 16 * 3)",
    color: "hsl(180deg 75% 64%)",
  },
};
